module.exports = __webpack_public_path__ + "static/bbis-hero-panels-2f5f05df59860b6a28468f87e33d5be6.jpg";